import { useGlobalStore } from '../../store/global-store/global-store';
import { isFeatureFlagEnabled } from './feature-flags';
import { FeatureFlag } from './feature-flags.type';

/**
 * Hook to check if a feature flag is enabled
 * @param {FeatureFlag} flag - The feature flag to check
 * @returns {boolean} true if the feature flag is enabled, false otherwise
 */
const useFeatureFlag = (flag: FeatureFlag): boolean => {
  const organization = useGlobalStore((state) => state.organization);
  return isFeatureFlagEnabled(organization, flag);
};

export { useFeatureFlag };
